module.exports = __webpack_public_path__ + "static/Ferie-2022-Dance-Art-Fun-ulotka-5ba7eed91fa22b926ba5b09390455247.pdf";